import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { useRemoteClientGet } from '@/configs/http-client';
import { usePromiseToast } from '../hooks/toast-promisse';
import { Endpoints } from '@/remote/endpoints';
import { ClientFormData } from '../validators/client-validator';
import ClientForm from '../forms/client-form';

type DialogProps = {
  id: number
  isOpen: boolean
  closeDialog: () => void
  updateList?: () => void
}

export function DialogEditClient({ id, isOpen = false, closeDialog, updateList }: DialogProps) {
  const { remoteClientGet } = useRemoteClientGet();
  const { triggerToast } = usePromiseToast();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ClientFormData>();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await remoteClientGet(`${Endpoints.client}/${id}`);
      setData(response?.data?.data);
    } catch (error) {
      setError('Erro ao carregar os dados...');
      console.error(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      triggerToast(fetchData());
    }
  }, [isOpen, id]);

  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Cliente</DialogTitle>
          <DialogDescription>Edição</DialogDescription>
        </DialogHeader>

        {isLoading && (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-acelerafit-green-300" />
          </div>
        )}

        {error && (
          <div className="text-red-500 p-4 text-center">
            {error}
          </div>
        )}

        {!isLoading && !error && (

          <ClientForm
            closeDialog={closeDialog}
            updateList={updateList}
            data={data}
          />

        )}

        <DialogFooter className="sm:justify-end w-148">
          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}